<form [formGroup]="form" class="one-column">
  <mat-form-field appearance="fill">
    <mat-label>Înălțime triunghi (E)</mat-label>
    <input matInput autocomplete="off" placeholder="Înălțime triunghi (E)" type="text" pattern="^[0-9]+[,.]?[0-9]*$"
           (change)="formDecimalInputChange($event, 'triangleHeight')" formControlName="triangleHeight" required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.triangleHeight?.value > 100">
    {{getNotInMetersWarningText('triangleHeight')}}
    <button (click)="updateToMeters('triangleHeight')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Bază triunghi (D)</mat-label>
    <input matInput autocomplete="off" placeholder="Bază triunghi (D)" type="text" pattern="^[0-9]+[,.]?[0-9]*$"
           (change)="formDecimalInputChange($event, 'triangleBase')" formControlName="triangleBase" required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.triangleBase?.value > 100">
    {{getNotInMetersWarningText('triangleBase')}}
    <button (click)="updateToMeters('triangleBase')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Înălțime trapez (B)</mat-label>
    <input matInput autocomplete="off" placeholder="Înălțime trapez (B)" type="text" pattern="^[0-9]+[,.]?[0-9]*$"
           (change)="formDecimalInputChange($event, 'trapezoidHeight')" formControlName="trapezoidHeight" required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.trapezoidHeight?.value > 100">
    {{getNotInMetersWarningText('trapezoidHeight')}}
    <button (click)="updateToMeters('trapezoidHeight')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Bază mare trapez (F)</mat-label>
    <input matInput autocomplete="off" placeholder="Bază mare trapez (F)" type="text" pattern="^[0-9]+[,.]?[0-9]*$"
           (change)="formDecimalInputChange($event, 'trapezoidBase')" formControlName="trapezoidBase" required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="this.form?.controls?.trapezoidBase?.value > 100">
    {{getNotInMetersWarningText('trapezoidBase')}}
    <button (click)="updateToMeters('trapezoidBase')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Bază mică trapez (C)</mat-label>
    <input matInput autocomplete="off" placeholder="Bază mică trapez (C)" type="text" pattern="^[0-9]+[,.]?[0-9]*$"
           (change)="formDecimalInputChange($event, 'ridgeLength')" formControlName="ridgeLength" required>
    <span matSuffix>metri</span>
  </mat-form-field>
  <div class="form-warning" *ngIf="hasBaseMeasurementsError()">
    Baza mare trebuie să fie mai mare decât baza mică
  </div>
  <div class="form-warning" *ngIf="this.form?.controls?.ridgeLength?.value > 100">
    {{getNotInMetersWarningText('ridgeLength')}}
    <button (click)="updateToMeters('ridgeLength')">Schimbă</button>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>Număr hornuri</mat-label>
    <input matInput autocomplete="off" type="number" min="0" max="10" pattern="^\d*$" formControlName="chimneys">
    <span matSuffix>nr.</span>
  </mat-form-field>
  <mat-checkbox formControlName="splitHeightInTwoRows" color="primary">
    <span class="prevent-select">Împarte înălțimea tablei pe două rânduri</span>
  </mat-checkbox>
  <em class="additional-info" style="margin-top: -5px; margin-bottom: 5px;">Înălțimea maximă la care livrăm tabla este de 5 metri, însă poate fi dificil de lucrat cu ea. Această opțiune va permite să împărțiți bucățile de tablă în 2 rânduri</em>
</form>


